import { isLocalHost } from '../helpers/environmentHelper';
import { BucketType } from '../interfaces/App';

export const API_SUBSCRIPTION_KEY: Record<BucketType, string> = {
  admin: isLocalHost()
    ? '323c8523b2bc4681a294a1896860b0af'
    : '219abde4cafc42c693da265df38f399a',
  agent: isLocalHost()
    ? '323c8523b2bc4681a294a1896860b0af'
    : '219abde4cafc42c693da265df38f399a',
  chat_agent: isLocalHost()
    ? '323c8523b2bc4681a294a1896860b0af'
    : '219abde4cafc42c693da265df38f399a',
  storage: isLocalHost()
    ? '323c8523b2bc4681a294a1896860b0af'
    : '219abde4cafc42c693da265df38f399a',
};

export const CHAT_WIDGET_PUBLIC_KEY = isLocalHost()
  ? 'ddf0db1ac2b84e48b7ac64455f3bbead'
  : '2832a8e4039f4757a1235048a1464305';

const USE_LOCAL_API = process.env.REACT_APP_USE_LOCAL_API === 'true';
const LOCAL_API_BASE =
  process.env.REACT_APP_LOCAL_API_BASE || 'http://localhost:7071/api';

export const BASE_API_URLS: Record<BucketType, string> = {
  admin: USE_LOCAL_API
    ? LOCAL_API_BASE
    : isLocalHost()
      ? 'https://sbx-elora-call-api.azure-api.net/admin'
      : 'https://prd-elora-call-api.azure-api.net/admin',
  agent: USE_LOCAL_API
    ? LOCAL_API_BASE
    : isLocalHost()
      ? 'https://sbx-elora-call-api.azure-api.net/agent'
      : 'https://prd-elora-call-api.azure-api.net/agent',
  chat_agent: USE_LOCAL_API
    ? LOCAL_API_BASE
    : isLocalHost()
      ? 'https://sbx-elora-call-api.azure-api.net/chat_agent'
      : 'https://prd-elora-call-api.azure-api.net/chat_agent',
  storage: USE_LOCAL_API
    ? LOCAL_API_BASE
    : isLocalHost()
      ? 'https://sbx-elora-call-api.azure-api.net/storage'
      : 'https://prd-elora-call-api.azure-api.net/storage',
};
